import { defineInlineEdit } from "../../../../../components/MobileList/inlineEdit";

/**
 * views/management/posType/form has a single field. `name` is the card's
 * heading rather than a tile, so the pencil sits next to the title.
 *
 * Guarded by the same permission as the table's edit button, so a user who
 * cannot open the dialog cannot edit inline either.
 */
export default defineInlineEdit({
  api: "posType",
  permission: "pos_type_edit",
  hydrate: false,
  toPayload: (source) => ({ name: source.name ?? "" }),
  fields: {
    name: { label: "الاسم", type: "text", required: true },
  },
});
